import { useTranslation } from 'react-i18next'
import { useSubmitLeadMutation } from '../../api/apiSlice'
import * as yup from 'yup'
import { Controller, useForm, useFormState } from 'react-hook-form'
import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import React from 'react'
import { AgreementDefinition, Lead } from '../../api/interfaces'
import DOMPurify from 'dompurify'
import { yupResolver } from '@hookform/resolvers/yup'
import Button from '@mui/material/Button'
import { formId, apiUrl } from '../../../dom'
import { useAppSelector } from '../../../app/hooks'
import { useNavigate } from 'react-router-dom'

export interface AgreementsProps {
    lead: Lead
    agreements: AgreementDefinition[]
}

export const Agreements = ({ lead, agreements }: AgreementsProps) => {
    const [triggerSubmitLead, { status, error }] = useSubmitLeadMutation()
    const token = useAppSelector((state) => state.form.token)
    const { t } = useTranslation()
    const navigate = useNavigate();

    const schema = yup.object({})

    const {
        control,
        handleSubmit,
        getValues,
    } =  useForm(
        {
            mode: 'onSubmit',
            reValidateMode: 'onChange',
            resolver: yupResolver(schema),
        }
    )
    const {
        errors
    } = useFormState({ control })

    React.useEffect(() => {
        if (status === 'fulfilled') {
            navigate('/Success')
        }
    }, [status])

    const agreementLabel = (agreement: AgreementDefinition): string => {
        return agreement.label.replace(
            '"document://',
            `"${apiUrl}/v1/forms/${formId}/leads/${token}/documents/`
        )
    }

    const onSubmit = (data: Record<string, any>) => {
        let agreementKeys: string[] = []
        Object.keys(data).forEach(key => {
            if (data[key] === true) {
                agreementKeys.push(key)
            }
        })
        const values = {
            token: token,
            acceptedAgreements: agreementKeys,
        }
        triggerSubmitLead(values)
    }

    return <>
        <Typography mb={4} variant="h5" component="h1">{t('Agreements.heading')}</Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
                {agreements.map(agreement =>
                    <Box key={agreement.key}>
                        <Controller
                            name={agreement.key}
                            control={control}
                            defaultValue={false}
                            render={({ field }) =>
                                <FormControlLabel
                                    sx={{ alignItems: 'flex-start' }}
                                    label={<Box sx={{paddingTop: '10px'}} dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(agreementLabel(agreement))}}/>}
                                    control={
                                        <Checkbox
                                            {...field}
                                        />
                                    }
                                />
                            }
                        />
                    </Box>
                )}
            </Stack>

            <Box mt={4}>
                <Button
                    type="submit"
                    color="cta"
                    variant="contained"
                    size="large"
                >
                    {t('signUpNow')}
                </Button>
            </Box>
        </form>
    </>
}
